(function () {
  if (window.GPMug) return;
  var STYLES = {
    black:  { accent: 0x050506, rough: 0.32, inner: 0x050506 },
    yellow: { accent: 0xF2C230, rough: 0.3, inner: 0xF2C230 },
    white:  { accent: 0xF7F7F5, rough: 0.26, inner: 0xF7F7F5 },
    enamel: { accent: 0xF4F4F2, rough: 0.35, inner: 0xF4F4F2, rim: 0xC9CCD1, rimMetal: 0.85 }
  };
  function drawDefault(lines, cb) {
    var W = 2048, H = 796, c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d');
    g.fillStyle = '#121216'; g.fillRect(0, 0, W, H);
    g.fillStyle = 'rgba(255,122,26,0.10)';
    for (var y = 40, row = 0; y < H; y += 110, row++) { for (var x = (row % 2) * 55; x < W; x += 110) { g.beginPath(); g.ellipse(x, y, 14, 9, 0.6, 0, Math.PI * 2); g.fill(); } }
    var gr = g.createRadialGradient(512, 398, 20, 512, 398, 380); gr.addColorStop(0, 'rgba(255,122,26,0.38)'); gr.addColorStop(1, 'rgba(255,122,26,0)');
    g.fillStyle = gr; g.fillRect(0, 0, 1024, H);
    g.save(); g.translate(200, 86); g.scale(2.6, 2.6); g.lineCap = 'round'; g.lineJoin = 'round';
    var P = function (d) { return new Path2D(d); };
    g.strokeStyle = '#F3E3CF'; g.lineWidth = 6; ['M96 26c-9 11 9 19 0 30', 'M120 18c-9 11 9 19 0 30', 'M144 26c-9 11 9 19 0 30'].forEach(function (d) { g.stroke(P(d)); });
    var handle = P('M178 104h10a28 28 0 0 1 0 56h-10');
    var body = P('M74 76h86a24 24 0 0 1 24 24v92a24 24 0 0 1 -24 24h-86a24 24 0 0 1 -24 -24v-92a24 24 0 0 1 24 -24z');
    g.strokeStyle = '#ffffff'; g.lineWidth = 27; g.stroke(handle); g.lineWidth = 12; g.stroke(body);
    g.strokeStyle = '#FF7A1A'; g.lineWidth = 15; g.stroke(handle);
    g.fillStyle = '#FF7A1A'; g.fill(body);
    g.fillStyle = '#D9580A'; g.fill(P('M61 76h112a11 11 0 0 1 0 22h-112a11 11 0 0 1 0 -22z'));
    g.strokeStyle = '#2B1D16'; g.lineWidth = 7; g.stroke(P('M82 132l24 7M152 132l-24 7'));
    g.fillStyle = '#2B1D16'; g.fill(P('M86 146a9 7 0 0 0 18 0Z M130 146a9 7 0 0 0 18 0Z'));
    g.fillStyle = '#FFB27A'; g.beginPath(); g.ellipse(76, 166, 10, 6, 0, 0, Math.PI * 2); g.ellipse(158, 166, 10, 6, 0, 0, Math.PI * 2); g.fill();
    g.stroke(P('M98 186q19-13 38 0'));
    g.restore();
    lines = (lines || []).filter(Boolean);
    function text() {
      g.textAlign = 'center'; g.textBaseline = 'middle';
      var size = 128; g.font = '700 ' + size + 'px Fredoka, sans-serif';
      while (size > 60 && Math.max.apply(null, lines.map(function (l) { return g.measureText(l).width; }).concat([0])) > 900) { size -= 6; g.font = '700 ' + size + 'px Fredoka, sans-serif'; }
      var lh = size * 1.08, y0 = 398 - (lines.length - 1) * lh / 2;
      lines.forEach(function (l, i) {
        g.fillStyle = 'rgba(0,0,0,0.5)'; g.fillText(l, 1541, y0 + i * lh + 7);
        g.fillStyle = (i === lines.length - 1) ? '#FF7A1A' : '#FFFFFF'; g.fillText(l, 1536, y0 + i * lh);
      });
      cb(c);
    }
    var done = false, go = function () { if (!done) { done = true; text(); } };
    if (document.fonts && document.fonts.load) { document.fonts.load('700 100px Fredoka').then(go, go); setTimeout(go, 1500); } else { go(); }
  }
  function mount(root, opts) {
    var T = window.THREE, canvas = root.querySelector('canvas');
    var renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    var scene = new T.Scene(), camera = new T.PerspectiveCamera(30, 1, 0.1, 100);
    camera.position.set(0, 1.1, 7.4); camera.lookAt(0, -0.05, 0);
    scene.add(new T.HemisphereLight(0xffffff, 0x2b1d16, 0.7));
    var L = function (col, i, x, y, z) { var d = new T.DirectionalLight(col, i); d.position.set(x, y, z); scene.add(d); };
    L(0xffffff, 1.15, 3, 4, 5); L(0xffb27a, 0.9, -4, 2, -3); L(0xffffff, 0.35, -3, 0, 4);
    var R = 1, H = 2.3, mug = new T.Group(); scene.add(mug);
    var accent = new T.MeshStandardMaterial({ color: 0x050506, roughness: 0.32 });
    var innerMat = new T.MeshStandardMaterial({ color: 0x050506, roughness: 0.5, side: T.BackSide });
    var rimMat = new T.MeshStandardMaterial({ color: 0x050506, roughness: 0.32 });
    var bodyMat = new T.MeshStandardMaterial({ color: 0xffffff, roughness: 0.24, metalness: 0.05 });
    var M = function (geo, mat) { var m = new T.Mesh(geo, mat); mug.add(m); return m; };
    M(new T.CylinderGeometry(R, R, H, 128, 1, true, Math.PI, Math.PI * 2), bodyMat);
    M(new T.CylinderGeometry(R * 0.94, R * 0.94, H, 96, 1, true), innerMat);
    var rim = M(new T.TorusGeometry(R * 0.97, 0.035, 16, 128), rimMat); rim.rotation.x = Math.PI / 2; rim.position.y = H / 2;
    var f1 = M(new T.CircleGeometry(R * 0.94, 64), accent); f1.rotation.x = -Math.PI / 2; f1.position.y = -H / 2 + 0.1;
    var f2 = M(new T.CircleGeometry(R, 64), accent); f2.rotation.x = Math.PI / 2; f2.position.y = -H / 2;
    var hg = new T.Group(), tor = new T.Mesh(new T.TorusGeometry(0.56, 0.13, 24, 64, Math.PI), accent);
    tor.rotation.z = -Math.PI / 2; hg.add(tor); hg.rotation.y = Math.PI / 2; hg.position.set(0, 0.05, -R + 0.03); mug.add(hg);
    mug.position.y = -0.1;
    function setStyle(n) {
      var s = STYLES[n] || STYLES.black;
      accent.color.setHex(s.accent); accent.roughness = s.rough; innerMat.color.setHex(s.inner);
      rimMat.color.setHex(s.rim || s.accent); rimMat.metalness = s.rimMetal || 0; rimMat.roughness = s.rim ? 0.3 : s.rough;
    }
    function setAccent(hex) {
      var h = parseInt(String(hex).replace('#', ''), 16); if (isNaN(h)) return;
      accent.color.setHex(h); innerMat.color.setHex(h); rimMat.color.setHex(h); rimMat.metalness = 0; accent.roughness = 0.3; rimMat.roughness = 0.3;
    }
    function applyTex(t) {
      t.encoding = T.sRGBEncoding; t.anisotropy = renderer.capabilities.getMaxAnisotropy();
      if (bodyMat.map) bodyMat.map.dispose();
      bodyMat.map = t; bodyMat.needsUpdate = true; root.classList.add('is-ready');
    }
    function setTexture(src) {
      if (!src) { drawDefault(opts.lines, function (cv) { applyTex(new T.CanvasTexture(cv)); }); return; }
      var ld = new T.TextureLoader(); ld.setCrossOrigin('anonymous');
      ld.load(src.indexOf('//') === 0 ? 'https:' + src : src, applyTex, undefined, function () { setTexture(''); });
    }
    setStyle(opts.style); setTexture(opts.texture);
    function size() { var w = root.clientWidth, h = root.clientHeight || w; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); }
    size(); if (window.ResizeObserver) { new ResizeObserver(size).observe(root); } else { window.addEventListener('resize', size); }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var rotY = Math.PI / 2 + 0.25, tiltX = 0.12, vel = 0, drag = false, lx = 0, ly = 0, idle = 0, vis = true, run = false;
    root.addEventListener('pointerdown', function (e) { drag = true; lx = e.clientX; ly = e.clientY; vel = 0; root.classList.add('is-touched'); try { root.setPointerCapture(e.pointerId); } catch (_) {} });
    root.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - lx, dy = e.clientY - ly; lx = e.clientX; ly = e.clientY; vel = dx * 0.012; rotY += vel; tiltX = Math.max(-0.25, Math.min(0.45, tiltX + dy * 0.004)); idle = 0; });
    var end = function () { drag = false; };
    root.addEventListener('pointerup', end); root.addEventListener('pointercancel', end); root.addEventListener('lostpointercapture', end);
    function loop() { if (run) return; run = true; requestAnimationFrame(tick); }
    function tick() {
      if (!vis) { run = false; return; }
      if (!drag) { vel *= 0.94; rotY += vel; idle++; if (!reduce && idle > 90 && Math.abs(vel) < 0.002) rotY += 0.006; tiltX += (0.12 - tiltX) * 0.04; }
      mug.rotation.y = rotY; mug.rotation.x = tiltX; renderer.render(scene, camera); requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { vis = en[0].isIntersecting; if (vis) loop(); }).observe(root);
    loop();
    return { setTexture: setTexture, setStyle: setStyle, setAccent: setAccent, spinTo: function (r) { rotY = r; vel = 0; idle = 0; } };
  }
  function styleFor(tags) {
    tags = (tags || '').toLowerCase();
    if (tags.indexOf('enamel') > -1) return 'enamel';
    if (tags.indexOf('color mug') > -1) return 'yellow';
    if (tags.indexOf('white mug') > -1) return 'white';
    return 'black';
  }
  function wire(holder, api) {
    var opts = holder.querySelectorAll('[data-gp-pick]'); if (!opts.length) return;
    var q = function (s) { return holder.querySelector(s); };
    var name = q('[data-gp-name]'), price = q('[data-gp-price]'), idIn = q('[data-gp-variant]'), btn = q('[data-gp-add]');
    function pick(o) {
      opts.forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
      api.setStyle(styleFor(o.dataset.tags)); if (o.dataset.accent) api.setAccent(o.dataset.accent); api.setTexture(o.dataset.texture); api.spinTo(Math.PI / 2 + 0.25);
      if (name) { name.textContent = o.dataset.name; name.href = o.dataset.url; }
      if (price) price.textContent = o.dataset.price;
      if (idIn) idIn.value = o.dataset.variant;
      if (btn) { var ok = o.dataset.available === 'true'; btn.disabled = !ok; btn.textContent = ok ? btn.dataset.label : 'Sold out'; }
    }
    opts.forEach(function (o) { o.addEventListener('click', function () { pick(o); }); });
    pick(opts[0]);
  }
  function auto(scope) {
    (scope || document).querySelectorAll('[data-gp-mug3d]:not([data-mounted])').forEach(function (root) {
      root.setAttribute('data-mounted', '');
      var holder = root.closest('[data-gp-mug-holder]');
      try {
        var api = mount(root, { texture: root.dataset.texture, style: root.dataset.style || styleFor(root.dataset.tags), lines: [root.dataset.line1, root.dataset.line2, root.dataset.line3] });
        root._gp = api;
        if (root.dataset.accent) api.setAccent(root.dataset.accent);
        root.dispatchEvent(new CustomEvent('gp:ready', { bubbles: true }));
        if (holder) wire(holder, api);
      } catch (e) { if (holder) holder.classList.add('is-fallback'); }
    });
  }
  window.GPMug = { mount: mount, auto: auto };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { auto(); }); else auto();
  document.addEventListener('shopify:section:load', function (e) { auto(e.target); });
})();